export default __webpack_public_path__ + "media/images/detect-a-fest-logo-d2be5e900a6a136d482be1e6404b89b4.svg";